import dayjs from "dayjs";

import duration from "dayjs/plugin/duration";
import relativeTime from "dayjs/plugin/relativeTime";
import timezone from "dayjs/plugin/timezone";
import utc from "dayjs/plugin/utc";

dayjs.extend(duration);
dayjs.extend(relativeTime);
dayjs.extend(timezone);
dayjs.extend(utc);

export { dayjs };

const TIMEZONE = "Asia/Shanghai";

export function dayjsOfZoned(tz: string = TIMEZONE) {
	return dayjs().tz(tz);
}

export function daysOfDate(value?: dayjs.Dayjs) {
	// 获取 value 到当前日期的天数
	return dayjs().diff(dayjs(value), "days");
}

export function startOfDate(date?: dayjs.Dayjs, unit: dayjs.UnitType = "d") {
	return dayjs(date).startOf(unit).toDate();
}

export function endOfDate(date?: dayjs.Dayjs, unit: dayjs.UnitType = "d") {
	return dayjs(date).endOf(unit).toDate();
}

/**
 * 格式化日期
 * @param date
 */
export function formatDate(date: dayjs.Dayjs | Date | null | undefined) {
	if (!date) return "";
	return dayjs(date).format("YYYY-MM-DD");
}

/**
 * 格式化日期时间
 * @param date
 */
export function formatDateTime(date: dayjs.Dayjs | Date | null | undefined) {
	if (!date) return "";
	return dayjs(date).format("YYYY-MM-DD HH:mm:ss");
}

/**
 * 格式化相对时间
 * @param time
 */
export function formatRelativeTime(
	time: dayjs.Dayjs | Date | string | null | undefined
) {
	if (!time) return "刚刚";
	const diff = dayjs().diff(time);
	const duration = dayjs.duration(diff);
	const minutes = duration.minutes();
	const hours = duration.hours();
	const days = duration.days();
	if (days > 0) {
		return `${days} 天前`;
	} else if (hours > 0) {
		return `${hours} 小时前`;
	} else if (minutes > 0) {
		return `${minutes} 分钟前`;
	} else {
		return "刚刚";
	}
}

export function formatToMinutes(seconds: number): string {
	const duration = dayjs.duration(seconds, "second");
	return duration.format("mm:ss");
}

export function formatKBtoMB(b: number): string {
	const kb = b / 1024;
	if (kb < 1024) {
		return `${kb}KB`;
	}
	const mb = kb / 1024;
	return `${mb.toFixed(2)}MB`;
}

// 新增函数：获取指定时区的当前时间
export function getCurrentTimeInZone(tz = "UTC") {
	return dayjs().tz(tz);
}

// 新增函数：将日期转换为指定时区
export function convertToTimezone(
	date: dayjs.Dayjs | Date | string,
	tz: string
) {
	return dayjs(date).tz(tz);
}

// 新增函数：格式化带时区的日期时间
export function formatDateTimeWithZone(
	date: dayjs.Dayjs | Date | string,
	tz: string,
	format = "YYYY-MM-DD HH:mm:ss z"
) {
	return dayjs(date).tz(tz).format(format);
}

/**
 * 计算两个日期之间的年龄
 * @param birthday
 * @param options
 */
export function calcAgeOfBirthday(
	birthday: Date | string | undefined | null,
	options?: { format?: string; ageOfBirth?: boolean } | string
) {
	if (!birthday) {
		return 0;
	}
	const format = typeof options === "string" ? options : options?.format;
	return dayjs().diff(dayjs(birthday, format), "year");
}

/**
 * 根据年龄计算出生日期
 * @param age
 * @param format
 */
export function calcBirthdayOfAge(
	age: number | string | null | undefined,
	format = "YYYY-MM-DD"
) {
	if (!age) {
		return "";
	}
	return dayjs()
		.subtract(Number.parseInt(age as any), "y")
		.format(format);
}
